import { css } from '@emotion/core';
import { Theme } from 'features/Theme';

export default {
  logoContainer: (theme: Theme, width: number) => css`
    label: logoContainer;
    text-align: center;
    margin: ${theme.mui.spacing(3)}px auto 0;
    width: ${theme.mui.spacing(width)}px;
    max-width: 100%;
    img {
      max-width: 100%;
    }
  `,
};
